import { get } from './index';

export const getPartnerships = () => get(`/api/v1/partnerships`);
